import api, { ValidateAxiosError, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

interface CreateFuncaoDto {
  id?: number;
  nome: string;
}

interface UpdateFuncaoDto extends Partial<CreateFuncaoDto> {
  id: number;
}

interface ReadFuncaoDto {
  id: number;
  nome: string;
  ultimoSalarioVigente?: number;
  ultimoSalarioVigencia?: string;
  editadoPor?: { id: number; nome: string };
  editadoEm?: Date;
}

export interface ReadFuncaoSalarioDto {
  id: number;
  vigencia: string;
  valor: number;
  editadoEm?: string;
}

interface CreateFuncaoSalarioDto {
  vigencia: string;
  valor: number;
}

interface UpdateFuncaoSalarioDto {
  vigencia?: string;
  valor?: number;
}

interface FindFuncaoDto {
  skip?: number;
  take?: number;
  id?: number;
  where?: string | null;
  orderBy?: string;
  orderField?: string;
  competencia?: string;
}

const endpoint = Endpoints.FUNCAO;

export async function createFuncao(dto: CreateFuncaoDto) {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a função.');
  }
}

export async function readFuncao(filters: FindFuncaoDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadFuncaoDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar função(s).');
  }
}

export async function updateFuncao(dto: UpdateFuncaoDto) {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a função.');
  }
}

export async function deleteFuncao(id: number) {

  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a função.');
  }
}

export async function listFuncaoSalarios(funcaoId: number) {
  try {
    const response = await api.get<ReadFuncaoSalarioDto[]>(`${endpoint}/${funcaoId}/salarios`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar salários da função.');
  }
}

export async function createFuncaoSalario(funcaoId: number, dto: CreateFuncaoSalarioDto) {
  try {
    const response = await api.post(`${endpoint}/${funcaoId}/salarios`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar salário da função.');
  }
}

export async function updateFuncaoSalario(salarioId: number, dto: UpdateFuncaoSalarioDto) {
  try {
    const response = await api.put(`${endpoint}/salarios/${salarioId}`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar salário da função.');
  }
}

export async function deleteFuncaoSalario(salarioId: number) {
  try {
    const response = await api.delete(`${endpoint}/salarios/${salarioId}`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover salário da função.');
  }
}
